"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = void 0;
const url_1 = require("url");
const react_1 = __importDefault(require("react"));
const withConfig_1 = require("../withConfig");
const DEFAULT_PAGE_NAME = 'home';
const CONTEXT_PATH = '/exchange';
const encodePagePath = (pagePath) => {
    const paths = pagePath.split('/');
    return paths.map((path) => encodeURIComponent(path)).join('/');
};
function getVersion({ version, isVersionNavigation, minorVersion, versionGroup }) {
    if (version && isVersionNavigation) {
        return `/${version}`;
    }
    if (minorVersion) {
        return `/minor/${minorVersion}`;
    }
    if (version || versionGroup) {
        return versionGroup ? `/version/${versionGroup}` : `/${version}`;
    }
    return '';
}
const stringifyStatus = (status) => `?status=${status}`;
const routesMap = {
    home: () => '/',
    newVersion: ({ groupId, assetId }) => `/${groupId}/${assetId}/versions/create/`,
    assetHome: ({ groupId, assetId }) => `/${groupId}/${assetId}/`,
    minor: ({ groupId, assetId, minorVersion, status }) => `/${groupId}/${assetId}/minor/${minorVersion}/${status ? stringifyStatus(status) : ''}`,
    assetDetailBase: ({ groupId, assetId, version, minorVersion, versionGroup, isVersionNavigation, isDraft }) => `/${groupId}/${assetId}${getVersion({
        isVersionNavigation,
        minorVersion,
        versionGroup,
        version
    })}/${isDraft ? 'draft/' : ''}`,
    page: (_a) => {
        var { pagePath } = _a, params = __rest(_a, ["pagePath"]);
        return `${routesMap.assetDetailBase(params)}${pagePath ? `pages/${encodePagePath(pagePath)}/` : ''}`;
    },
    pageDraft: (_a) => {
        var { pagePath = DEFAULT_PAGE_NAME } = _a, params = __rest(_a, ["pagePath"]);
        return routesMap.page(Object.assign(Object.assign({}, params), { pagePath, isDraft: true }));
    },
    pageEdit: (_a) => {
        var { pagePath = DEFAULT_PAGE_NAME } = _a, params = __rest(_a, ["pagePath"]);
        return `${routesMap.assetDetailBase(Object.assign(Object.assign({}, params), { isDraft: true }))}edit/${encodePagePath(pagePath)}/`;
    },
    file: ({ organizationId, groupId, assetId, version, fileClassifier, packaging }) => `/organizations/${organizationId}/assets/${groupId}/${assetId}/${version}/files/${fileClassifier ? `${fileClassifier}/` : ''}${packaging}`
};
/*
 * Gets the path for a route by name using params
 */
const getPath = (name, params, options) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const config = react_1.default.useContext(withConfig_1.ConfigContext);
    let prePath = CONTEXT_PATH;
    if (options === null || options === void 0 ? void 0 : options.excludeContextPath) {
        prePath = '';
    }
    if (options === null || options === void 0 ? void 0 : options.useFullURLPath) {
        prePath = `${(0, url_1.format)(config.platform.uri)}${CONTEXT_PATH}`;
    }
    if (!routesMap[name]) {
        return null;
    }
    return `${prePath}${routesMap[name](params)}`;
};
exports.getPath = getPath;
__exportStar(require("./types"), exports);
